import { addDaysToDateKey, localDateKey, localDateKeyFromIso } from './dateKey';

/** Consecutive calendar days with at least one logged workout, ending today or yesterday. */
export function workoutDayStreak(workoutDateKeys: string[]): number {
  const days = new Set(workoutDateKeys);
  if (days.size === 0) return 0;
  const today = localDateKey();
  const start = days.has(today) ? today : days.has(addDaysToDateKey(today, -1)) ? addDaysToDateKey(today, -1) : '';
  if (!start) return 0;
  let streak = 0;
  let key = start;
  while (days.has(key)) {
    streak += 1;
    key = addDaysToDateKey(key, -1);
  }
  return streak;
}

export function workoutDayStreakFromIso(dates: string[]): number {
  return workoutDayStreak(dates.map(localDateKeyFromIso));
}
